/**
 * Servicio API para SB Vertical Video Campaigns
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const SbVerticalVideoCampaignAPI = {

    /**
     * Sube archivos: video, CSV de targeting, ASIN producto
     */
    uploadFiles: async function (video, targetingCSV, negativeCSV) {
        const formData = new FormData();

        if (video) formData.append('video', video);
        if (targetingCSV) formData.append('targetingCSV', targetingCSV);
        if (negativeCSV) formData.append('negativeCSV', negativeCSV);

        const response = await fetch(`${API_BASE_URL}/sb-vertical-video/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al subir archivos');
        }

        return await response.json();
    },

    /**
     * Crea una campaña de video vertical
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('startDate', options.startDate);
        formData.append('endDate', options.endDate || '');
        formData.append('defaultBid', options.defaultBid);
        formData.append('state', options.state);
        formData.append('brandEntityId', options.brandEntityId);
        formData.append('targetingType', options.targetingType); // 'keywords' or 'products'
        formData.append('adFormat', 'video');

        // Targeting data
        formData.append('targeting', JSON.stringify(options.targeting));
        formData.append('productAsin', options.productAsin);

        // Video file
        if (options.video) formData.append('video', options.video);

        // Negatives
        if (options.negatives) {
            formData.append('negatives', JSON.stringify(options.negatives));
        }

        const response = await fetch(`${API_BASE_URL}/sb-vertical-video/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al crear campaña');
        }

        return await response.json();
    },

    /**
     * Obtiene marcas disponibles
     */
    getBrands: async function (profileId) {
        const response = await fetch(`${API_BASE_URL}/sb-vertical-video/brands?profileId=${profileId}`);
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al obtener marcas');
        }
        return await response.json();
    }
};

export default SbVerticalVideoCampaignAPI;
